import { render, staticRenderFns } from "./ModalHomologarAdjudicarItemLote.vue?vue&type=template&id=2051c15c&scoped=true"
import script from "./ModalHomologarAdjudicarItemLote.vue?vue&type=script&lang=js"
export * from "./ModalHomologarAdjudicarItemLote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2051c15c",
  null
  
)

export default component.exports